<template>
  <Modal class="confirm-modal" :hasClose="true" @close="$emit('close')">
    <h2
      slot="header"
      class="text-ma-black-1 text-center text-xl m-3 font-semibold"
    >
      {{ title }}
    </h2>

    <p class="m-auto w-full mtext-a-gray-3 text-base mb-4 text-center max-w-md">
      {{ description.replace(/<%name%>/g, name) }}
    </p>

    <div slot="footer">
      <div class="mx-auto mb-3 flex justify-center w-full max-w-md">
        <button
          @click="$emit('close')"
          class="cursor-pointer inline-block w-32 mr-4 md:w-40 font-semibold text-center btn btn--purple-outline text-base py-2"
        >
          {{ no }}
        </button>
        <button
          @click="$emit('confirm')"
          :disabled="loading"
          class="cursor-pointer inline-block w-32 md:w-40 font-semibold text-center btn btn--primary text-white text-base py-2"
        >
          <template v-if="loading">
            <div class="animation-spin btn-spinner inline-block ml-1" v-cloak>
              <i class="icon--spinner2"></i>
            </div>
            Waiting...
          </template>
          <template v-else>
            {{ yes }}
          </template>
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  components: {
    Modal,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "Confirm",
    },
    description: {
      type: String,
      required: false,
      default: "Are you sure?",
    },
    yes: {
      type: String,
      required: false,
      default: "Confirm",
    },
    no: {
      type: String,
      required: false,
      default: "Cancel",
    },
    name: {
      type: String,
      required: false,
      default: "the member",
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style></style>
